module.exports = __webpack_public_path__ + "files/23d8b29cc89b2b86cdb70515d4b41684.png";